import { DeliveryMode } from '../../../../../../services/exports/Constants';

export default {
  types: {
    circle: 'Cerchio',
    polygon: 'Poligono',
    zip: 'CAP',
  },
  fields: {
    name: {
      label: 'Nome',
    },
    color: {
      label: 'Colore',
    },
    min_threshold: {
      label: 'Importo minimo ordine',
    },
    max_threshold: {
      label: 'Importo massimo ordine',
    },
    fee: {
      [DeliveryMode.Internal]: {
        label: 'Costo di consegna',
      },
      [DeliveryMode.External]: {
        label: 'Commissione a carico del ristorante',
      },
    },
    zip_codes: {
      label: 'CAP (uno per riga)',
    },
  },
  labels: {
    hidden: '(nascosto)',
  },
  buttons: {
    save: 'Salva',
    cancel_changes: 'Annulla modifiche',
    add_max_order_amount: 'Aggiungi importo massimo ordine',
  },
  modals: {
    delete_confirmation: {
      title: 'Sei sicuro di voler eliminare {{name}}',
    },
  },
  toasts: {
    failed_to_save_changes: 'Salvataggio modifiche per {{name}} non riuscito',
    delivery_zone_got_updated: 'Modifiche per {{name}} salvate con successo',
    failed_to_delete_delivery_zone: 'Eliminazione di {{name}} non riuscita',
    delivery_zone_got_deleted: '{{name}} eliminato con successo',
  },
};
